import { couponActionTypes } from '~/store/legacy/actions/couponActions.js';

export const initState = {
  coupon: null,
  couponLoaded: false,
  couponLoadFailed: false,

  redeemed: false,
  redeemFailed: false,

  rewardChecked: false,
  rewardUsed: false,
};

const CouponReducer = (state = initState, aciton) => {
  switch (aciton.type) {
    case couponActionTypes.getCoupon:
      return initState;

    case couponActionTypes.getCouponFailed:
      return {
        ...state,
        ...{
          coupon: null,
          couponLoaded: true,
          couponLoadFailed: true,
        },
      };

    case couponActionTypes.getCouponSuccess:
      return {
        ...state,
        ...{
          coupon: aciton.coupon,
          couponLoaded: true,
          couponLoadFailed: false,
        },
      };

    case couponActionTypes.redeemCouponFailed:
      return {
        ...state,
        ...{
          redeemed: false,
          redeemFailed: true,
        },
      };

    case couponActionTypes.redeemCouponSuccess:
      return {
        ...state,
        ...{
          redeemed: true,
          redeemFailed: false,
        },
      };

    case couponActionTypes.checkReward:
      return {
        ...state,
        ...{
          rewardChecked: false,
          rewardUsed: false,
        },
      };

    case couponActionTypes.checkRewardSuccess:
      return {
        ...state,
        ...{
          rewardChecked: true,
          rewardUsed: false,
        },
      };

    case couponActionTypes.checkRewardFailed:
      return {
        ...state,
        ...{
          rewardChecked: true,
          rewardUsed: true,
        },
      };

    case couponActionTypes.redeemRewardSuccess:
      return {
        ...state,
        ...{
          redeemed: true,
          redeemFailed: false,
        },
      };

    default:
      return state;
  }
};

export default CouponReducer;
